var app = angular.module('directives.cardPayBlock');

app.directive('cardPayBlock', [
    'configs',
    '$translate',
    '$state',
    '$rootScope',
    'ClientCards',
    function(configs, $translate, $state, $rootScope, ClientCards) {
        var tmplUrl;
        var parsedLink = $state.current.url.split('/');

        try {
            //looking for template with moduleName
            tmplUrl = require('../templates/' + $state.current.name.replace('pages.','') + '.html');
        }
        catch (e) {
            //if error, use default template
            tmplUrl = require('../templates/index.html');
        }

        parsedLink.forEach(function(key) {
            if (key == 'l') {
                tmplUrl = require('../templates/index.html');
            }
            if (key == 'ls') {
                tmplUrl = require('../templates/service.html');
            }
        });

        return {
            restrict: "E",
            template: tmplUrl,
            scope: {
                methodswitcher: '=',
                gaPayInCard: '=',
                disabledinputs: '='
            },
            controller:'cardCtrl',
            link: function(scope, element, attrs, ctrl) {
            }
        };
    }
]);

app.controller('cardCtrl',function ($state, $scope, $timeout, ClientCards, Authentication, $stateParams, Pay, Storage) {
    var myInput = document.getElementById('cvc');

    $scope.ClientCards = ClientCards;
    $scope.showMPForm = false;
    $scope.isLogged = Authentication.isLogged;
    $scope.Pay = Pay;
    $scope.gaPayMethodCanBeSelected = $scope.gaPayInCard;

    ClientCards.data.mpStatus = Storage.getItem('mp_status');

    if(myInput) {
        myInput.onpaste = function(e) {
            e.preventDefault();
        };
    }

    $scope.mpAuth = false;

    $scope.$on('$destroy', function () {
        ClientCards.data.c2c = false;
        ClientCards.addMasterpassCard(false);
    });

    $scope.setActiveCard = function(cardList) {
        var cardType = cardList == 'listMP' ? 'masterpass' : '';
        var defaultCard = ClientCards[cardList].find(function (card) {
            return card.is_default;
        });

        if(defaultCard){
            ClientCards.setClientCard(defaultCard, cardType);
        } else if(ClientCards[cardList].length) {
            ClientCards.setClientCard(ClientCards[cardList][0], cardType);
        } else {
            ClientCards.addMasterpassCard(false);
            ClientCards.userInputFnc('number');
        }
    };

    if ($stateParams.infoState) {
        $scope.showMPForm = true;
    }

    $scope.toggleMPModal = function (status, event) {

        if(ClientCards.data.mpStatus != 'AUTHORIZED'){
            if(event && event.target && event.target.id == 'mp-modal') {
                $scope.showMPForm = false;
            } else {
                $scope.showMPForm = status;
            }
        } else {
            if(status){
                $scope.setActiveCard('listMP');
                // $scope.showMPForm = status;
            } else {
                ClientCards.addMasterpassCard(false);
                ClientCards.userInputFnc('number');
                // $scope.showMPForm = false;
            }
            ClientCards.data.masterpass = status;
        }

        if($scope.isLogged){
            if (status && ClientCards.listMP.length > 0 && ClientCards.data.showMPcards) {
                $scope.setActiveCard('listMP');
                // $scope.showMPForm = status;
            } else if(!status && ClientCards.list.length > 0) {
                $scope.setActiveCard('list');
                // $scope.showMPForm = false;
            } else {
                ClientCards.addMasterpassCard(false);
                ClientCards.userInputFnc('number');
                // $scope.showMPForm = false;
            }
            ClientCards.data.masterpass = status;
        }

        if(event == 'close'){
            $scope.showMPForm = false;
        }

    };
    
    $scope.changeCardNumberHandler = function (cardNumber, usrInpt) {
        $scope.gaPayMethodCanBeSelected = !cardNumber;

        ClientCards.changeCardNumber(cardNumber, usrInpt);
    }
    
    $scope.checkCardValue = function () {
        if (ClientCards.data.viewExpire && ClientCards.data.viewExpire.year && ClientCards.data.viewExpire.year.length > 2) {
            ClientCards.data.viewExpire.year = ClientCards.data.viewExpire.year.slice(-2);
        }
    }

    $scope.init = function () {

        if ($state.current.name.replace('pages.','') == 'cardtocard') {
            ClientCards.data.c2c = true;
        }
    };

    $scope.init();
});



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/cardPayBlock/directives/cardPayBlock.js
 ** module id = 140
 ** module chunks = 1
 **/